var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckboxChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 1161.11 1161.11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#35a4dd",
    d: "M475.61 812.13h-.24a32.52 32.52 0 01-22.95-9.72L259.84 606.34a32.5 32.5 0 1146.37-45.54l169.73 172.79 379.3-375.22A32.5 32.5 0 11901 404.58L498.46 802.74a32.48 32.48 0 01-22.85 9.39z"
  })));
}

export default SvgCheckboxChecked;